export enum NumberType {
  integer = 1,
  float = 2
}